import { useShallow } from 'zustand/react/shallow';
import storage from '../../../../../../hooks/useStorage/useStorage';
import LangEnum from '../../../../../../lang/LangEnum';
import useOrderBookStore from '../../../../../../stores/OrderBook/orderBook.store';
import useProductDetailsStore from '../../../../../../stores/ProductDetails/productDetails.store';
import { OrderFilterStateEnum } from '../../../../../../stores/ProductDetailsFilter/productDetailsFilter.types';
import useOrderBook from '../../../../../order-book/hooks/useOrderBook';
import ProductFilterToggleButton from './button/components/ProductFilterToggleButton';

const OrdersFilter = () => {
  const {
    removeCopiedGrid,
    handleChangeProductGridParams,
    productGridParams,
    orderFilterState,
    handleChangeOrderFilterState,
  } = useProductDetailsStore(
    useShallow((state) => ({
      productGridParams: state.productGridParams,
      orderFilterState: state.ordersFilterState,
      removeCopiedGrid: state.removeCopiedGrid,
      handleChangeOrderFilterState: state.handleChangeOrderFilterState,
      handleChangeProductGridParams: state.handleChangeProductGridParams,
    })),
  );

  const isAllOrdersSelected = !!productGridParams.orderIds && productGridParams.orderIds.length > 1;
  const { selectedOrder } = useOrderBookStore(
    useShallow((state) => ({
      selectedOrder: state.selectedOrder,
    })),
  );
  const { allOrders } = useOrderBook();

  const handleSelectOrder = () => {
    if (!selectedOrder?.id) {
      return;
    }

    removeCopiedGrid();
    handleChangeOrderFilterState(OrderFilterStateEnum.SELECTED_ORDER);
    handleChangeProductGridParams({ ...productGridParams, orderIds: [selectedOrder?.id] });
    storage.setProductDetailsFilter(storage.getSessionId() as string, {
      isAllOrdersFilterSelected: false,
    });
  };

  const handleToggleButton = () => {
    if (orderFilterState === OrderFilterStateEnum.ALL_ORDERS) {
      return handleSelectOrder();
    }

    if (allOrders.length <= 1) {
      return;
    }

    removeCopiedGrid();
    handleChangeOrderFilterState(OrderFilterStateEnum.ALL_ORDERS);
    handleChangeProductGridParams({
      ...productGridParams,
      orderIds: allOrders.map((order) => order?.id),
    });

    storage.setProductDetailsFilter(storage.getSessionId() as string, {
      isAllOrdersFilterSelected: true,
    });
  };

  return (
    <ProductFilterToggleButton
      value="orders"
      onClick={handleToggleButton}
      selected={isAllOrdersSelected}
      label={LangEnum.PRODUCT_DETAILS_ORDERS_FILTER_LABEL}
    />
  );
};

export default OrdersFilter;
